import axios from 'axios'

export default {
    getFiles(id){
        return axios.get('/files/memberphoto/' + id)
            .then(response => {
                return response.data
            })
    },
    getFilesOnlineClass(id){
        return axios.get('/files/onlineclass/' + id)
            .then(response => {
                return response.data
            })
    },
    uploadIkidPhoto(formdata){
        return axios.post('/files/memberphoto', formdata)
            .then(response => {
                return response.data
            })
    },
    uploadICareImage(formdata){
        return axios.post('/files/icareimage', formdata)
            .then(response => {
                return response.data
            })
    },    
    uploadGlobalImage(key,formdata){
        return axios.post('/files_global/'+key, formdata)
            .then(response => {
                return response.data
            })
    },   
}